import React from 'react';

const DigitImage = (props) => {
	const digit = `${props.value}`;

	const color = props?.color ?? false;
	const force_center = props?.force_center ?? false;

	let only_digit = props?.only_digit ?? true;
	let digits_in_number;
	if(digit != 'colon' && digit != 'dot') {
		digits_in_number = digit.split("");
	} else {
		only_digit = true;
		digits_in_number = [digit];
	}

	const classes = ['gui_digit'];
	if(force_center) classes.push('mod_align_center');

	return (
		<div class={classes.join(" ")}>
			{digits_in_number.map((digit, i) => {
				if(digit == "." || digit == ",") digit = 'dot';
				if(digit == ":") digit = 'colon';

				const span_classes = ['is_digit', `is_${digit}`];
				if(!only_digit) span_classes.push('is_flipclock');

				return (
					<span key={i} class={span_classes.join(" ")}>
						<span class={`knk-counter-number-${digit}`} style={(color) ? { color } : null} />
					</span>
				)
			})}
		</div>
	);
};

export default DigitImage;